import type { WatchSocketTransport } from './watchSocket.types';

/** The part of a socket.io client the connector needs from a socket the app already owns. */
export interface WatchSharedSocket {
  on: (event: string, listener: (payload: unknown) => void) => void;
  off: (event: string, listener: (payload: unknown) => void) => void;
  emit: (event: string, payload: unknown, ack?: (response: unknown) => void) => void;
  connected?: boolean;
}

/**
 * Wraps a socket the connector does not own, so tearing the connector down detaches only the
 * listeners it added and leaves the socket - and everything else listening on it - untouched.
 *
 * Assumes the socket was already connected (with auth, if required) to the proxy's namespace by
 * its owner; this wrapper does not itself establish the connection.
 */
export const createSharedSocketTransport = (socket?: WatchSharedSocket | null): WatchSocketTransport => {
  const attached: [string, (payload: unknown) => void][] = [];

  return {
    on: (event, listener) => {
      attached.push([event, listener]);
      socket?.on(event, listener);
    },
    emit: (event, payload, ack) => {
      socket?.emit(event, payload, ack);
    },
    disconnect: () => {
      attached.forEach(([event, listener]) => socket?.off(event, listener));
      attached.length = 0;
    },
    isConnected: () => Boolean(socket?.connected),
  };
};
